import { render, staticRenderFns } from "./novedades.vue?vue&type=template&id=7169a364&lang=html&"
import script from "./novedades.vue?vue&type=script&lang=js&"
export * from "./novedades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports